<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-6 mt-2 mt-8 sm:-mt-px mb-8">
        <div class="font-bold pt-6 text text-blue-500 tracking-wide uppercase">
            {{ $t('Listing Side') }}
        </div>

        <fee-revenue
            :commission_detail="commission_detail"
            @updated="feeUpdated"
            :read_only="read_only"
        />

        <referral-fees
            :fee="fee"
            :commission_detail="commission_detail"
            @updated="referralFeesUpdated"
            :read_only="read_only"
        />

        <concession
            :commission_detail="commission_detail"
            :paid_off_top="list_side_paid_off_top"
            v-model="list_side_list_concession"
            @updated="paidOffTopUpdated"
            :read_only="read_only"
        />

        <bonus
            v-model="list_side_list_bonus"
            :read_only="read_only"
        />

        <net-fee
            :net_fee="net_fee"
            :net_to_agent="net_to_agent"
            v-model="list_side_percent_split"
            :read_only="read_only"
        />

        <other-fees
            :commission_detail="commission_detail"
            v-model="list_side_other_fees"
            :read_only="read_only"
        />

        <total-net-to-agent
            :total_net_to_agent="total_net_to_agent"
            :read_only="read_only"
        />

        <managing-broker-approved
            :commission_detail="commission_detail"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import FeeRevenue from './list-side/fee-revenue.vue';
import Bonus from './list-side/bonus.vue';
import Concession from './list-side/concession.vue';
import NetFee from './list-side/net-fee.vue';
import OtherFees from './list-side/other-fees.vue';
import TotalNetToAgent from './list-side/total-net-to-agent.vue';
import ManagingBrokerApproved from './list-side/managing-broker-approved.vue';
import ReferralFees from './list-side/referral-fees.vue';
import MoneyFunctions from '../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        FeeRevenue,
        Bonus,
        Concession,
        NetFee,
        OtherFees,
        TotalNetToAgent,
        ManagingBrokerApproved,
        ReferralFees,
    },

    props: {
        commission_detail: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            list_side_list_revenue: this.commission_detail.list_side_list_revenue,
            list_side_list_bonus: this.commission_detail.list_side_list_bonus,
            list_side_list_concession: this.commission_detail.list_side_list_concession,
            list_side_paid_off_top: this.commission_detail.list_side_paid_off_top,
            list_side_percent_split: this.commission_detail.list_side_percent_split,
            list_side_other_fees: this.commission_detail.list_side_other_fees,
            list_side_referral_fee_total: this.commission_detail.list_side_referral_fee_total,
        }
    },

    computed: {
        fee() {
            return this.moneyVal(this.list_side_list_revenue);
        },
        referral_fee() {
            return this.moneyVal(this.list_side_referral_fee_total);
        },
        concession() {
            return this.moneyVal(this.list_side_list_concession);
        },
        bonus() {
            return this.moneyVal(this.list_side_list_bonus);
        },
        net_fee() {
            return this.formatMoney(
                this.fee
                - this.referral_fee
                - (this.list_side_paid_off_top ? this.concession : 0)
                + this.bonus
            );
        },
        net_to_agent() {
            if (! this.net_fee || ! this.list_side_percent_split) {
                return null;
            }

            return this.formatMoney(
                this.net_fee
                * (this.list_side_percent_split / 100)
                - (this.list_side_paid_off_top ? 0 : this.concession)
            );
        },
        total_net_to_agent() {
            return this.formatMoney(this.net_to_agent - this.moneyVal(this.list_side_other_fees));
        },
    },

    methods: {
        feeUpdated(val) {
            this.list_side_list_revenue = val;
        },
        referralFeesUpdated(val) {
            this.list_side_referral_fee_total = val;
        },
        paidOffTopUpdated(val) {
            this.list_side_paid_off_top = val;
        },
    },

    watch: {
        total_net_to_agent(val) {
            store.state.list_side_total_net_to_agent = val;
        },
    },
}
</script>
